import api from './axios';

export interface PriceListItem {
  id: number;
  name: string;
  unit: string;
  cableType: string;
  priceTl: number | null;
  priceUsd: number | null;
  listVersion: string;
  active: boolean;
}

export const getPriceList = (type?: string) =>
  api.get<PriceListItem[]>('/price-list', { params: type ? { type } : {} }).then(r => r.data);

export const updatePriceListItem = (id: number, data: Partial<PriceListItem>) =>
  api.put<PriceListItem>(`/price-list/${id}`, data).then(r => r.data);

export const createPriceListItem = (data: Partial<PriceListItem>) =>
  api.post<PriceListItem>('/price-list', data).then(r => r.data);
